<template>
  <div>
    <div v-for="(group, key, index) in groupsList" :key="key">
      <v-divider v-if="index > 0" class="my-3" />

      <h5 class="mb-3">{{ groups[group.key]?.name }}</h5>
      <v-row dense class="mx-0">
        <v-col
          v-for="component in group.components"
          :key="component.key"
          cols="12"
          sm="6"
          md="4"
          lg="3"
          xl="2"
        >
          <v-card
            @click="exportData(component.key)"
            rounded="lg"
            class="pa-3 h-full d-flex flex-column"
            outlined
          >
            <div class="d-flex gap-2 align-center mb-1">
              <v-icon size="26">{{ component.icon }}</v-icon>
              <b class="mb-0 text-15 lh-1">{{ component.name }}</b>
            </div>
            <p class="mb-2">{{ component.description }}</p>
            <v-spacer />
            <div class="d-flex gap-2 align-center">
              <v-chip
                v-for="format in component.formats"
                :key="format"
                :color="types[format].color"
                class="px-2"
                small
                label
              >
                {{ types[format].name }}
              </v-chip>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <ExecuterModal />
  </div>
</template>

<script>
import ExecuterModal from "@/components/global/executer/ExecuterModal.vue";

const exporterComponents = {};
const context = require.context(
  "../../global/executer/modules/export",
  true,
  /\.vue$/
);

context.keys().forEach((key) => {
  const componentName = key.replace(/^\.\/(.*)\.\w+$/, "$1");
  exporterComponents[componentName] = context(key).manifest;
});

export default {
  name: "Exporter",
  components: {
    ExecuterModal,
  },
  data: () => ({
    exporterComponents,
    groups: {
      global: { name: "Geral" },
      party: { name: "Evento" },
    },
    types: {
      xlsx: {
        name: "Excel",
        color: "success",
      },
      csv: {
        name: "CSV",
        color: "info",
      },
      pdf: {
        name: "PDF",
        color: "error",
      },
    },
  }),
  computed: {
    groupsList() {
      return Object.keys(this.exporterComponents).reduce((acc, component) => {
        const group = this.exporterComponents[component]?.group || "global";
        if (!acc[group]) {
          acc[group] = {
            key: group,
            components: [],
          };
        }
        acc[group].components.push({
          ...this.exporterComponents[component],
          key: component,
        });
        return acc;
      }, {});
    },
  },
  methods: {
    exportData(componentKey) {
      this.$root.$emit("executer:run", {
        executer: `export/${componentKey}`,
      });
    },
  },
};
</script>
